import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faCalendarCheck, faMapLocation, faShoppingCart, faTags, faTicket, faArrowsSpin, faGift } from '@fortawesome/free-solid-svg-icons';
import UserContext from '../../navigation/context/userContext';
import { useTranslation } from 'react-i18next';
import { faNfcSymbol } from '@fortawesome/free-brands-svg-icons';

export default function ManagementListItems({ onItemClick }) {
    const { t } = useTranslation();
    const { userData } = useContext(UserContext);
    const history = useHistory();
    const location = useLocation();
    const theme = useTheme();

    const redireccionar = (ruta) => {
        history.push(ruta);
        // 2. Ejecutamos la función para cerrar el menú si existe
        if (onItemClick) {
            onItemClick();
        }
    };

    const MenuItemCustom = ({ route, icon, text }) => {
        const isActive = location.pathname.includes(route); 

        return (
            <ListItem disablePadding sx={{ mb: 0.5 }}>
                <ListItemButton
                    onClick={() => redireccionar(route)}
                    sx={{
                        borderRadius: 3,
                        minHeight: 46,
                        backgroundColor: isActive ? '#e3f2fd' : 'transparent',
                        color: isActive ? theme.palette.primary.main : '#555',
                        '&:hover': {
                            backgroundColor: isActive ? '#e3f2fd' : '#f5f5f5',
                        },
                    }}
                >
                    <ListItemIcon sx={{ minWidth: 40, color: isActive ? theme.palette.primary.main : '#888' }}>
                        <FontAwesomeIcon icon={icon} />
                    </ListItemIcon>
                    <ListItemText 
                        primary={text} 
                        primaryTypographyProps={{ 
                            fontWeight: isActive ? 700 : 500,
                            fontSize: '0.95rem'
                        }} 
                    />
                </ListItemButton>
            </ListItem>
        );
    };

    return (
        <>
            {userData.user.type === 'company' && (
                <>
                    <MenuItemCustom route="/ai" icon={faTags} text='IA' />
                    <MenuItemCustom route="/products" icon={faTags} text={t('merchantPanel.menuOptions.products')} />
                    <MenuItemCustom route="/assets" icon={faBuilding} text={t('merchantPanel.menuOptions.assets')} />
                    <MenuItemCustom route="/merchant/loyalty" icon={faGift} text='Promociones' />
                    <MenuItemCustom route="/orders" icon={faShoppingCart} text={t('merchantPanel.menuOptions.orders')} />
                    <MenuItemCustom route="/subscriptions" icon={faArrowsSpin} text={t('merchantPanel.menuOptions.subscriptions')} />
                    <MenuItemCustom route="/reservations" icon={faCalendarCheck} text={t('merchantPanel.menuOptions.bookings')} />
                </>
            )}
            
            <MenuItemCustom route="/events" icon={faTicket} text={t('merchantPanel.menuOptions.events')} />
            <MenuItemCustom route="/cashless" icon={faNfcSymbol} text={t('merchantPanel.menuOptions.cashless')} />

            {userData.user.type === 'owner' && (
                <MenuItemCustom route="/tourism" icon={faMapLocation} text="Turismo" />
            )}
        </>
    );    
}